import img1 from './1.jpg';
import img2 from './2.jpg';
import img3 from './3.jpg';
import img4 from './4.jpg';

export default function Activities() {
  const activities = [
    { src: img1, title: "海事システム工学科の実験船の修理" },
    { src: img2, title: "水中ロボコン" },
    { src: img3, title: "国際ロボット展での展示" },
    { src: img4, title: "飛行ロボコン" },
  ];

  return (
    <div className="fade-in activities-container">
      <h2>活動内容</h2>
      <p>飛行ロボコン、水中ロボコンを軸にモノづくり全般に取り組んでいます。</p>

      <div className="activities-grid">
        {activities.map((activity, index) => (
          <div className="activity-card" key={index}>
            <img src={activity.src} alt={activity.title} className="activity-img" />
            <div className="activity-title">{activity.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
